<template>
  <el-drawer
    title="任务详情"
    :visible="true"
    direction="rtl"
    :before-close="handleClose"
    :destroy-on-close="true"
    :size="isFullScreen ? '100vw' : '30vw'"
  >
    <center class="rectitle" v-if="isUnqualified">
      <div class="rectitle-text">
        <span style=" font-size: 16px;color: #EA0D0D;">
          不可结算
        </span>
        <span style="font-size:14px">数据检测不合格，系统已自动拦截</span>
      </div>
    </center>
    <!-- 查询结果包含 重复图片的话 展示-->
    <el-row v-if="isPicRepeat" style="padding:5px 5px ;text-align: left">
      <span>
        <i class="el-icon-warning" style="color: #ff4949"></i>
        <span style="font-weight: bold">图片查重提示：</span>
        <span style="color: #ff4949">*</span>
        标记任务记录内提交的图存在重复,
        <el-link
          @click="showRepeat"
          style="color:#409EFF;text-decoration: underline"
        >
          点击查看
        </el-link>
      </span>
    </el-row>
    <div class="task-detail-container" @click="fileViewerFocus">
      <el-form
        :model="form"
        class="demo-form-inline"
        label-position="right"
        label-suffix=":"
      >
        <template v-if="![5, 6, 7, 20, 21].includes(detail.projectType)">
          <el-form-item
            v-for="(item, index) in detail.values"
            :label="item.label"
            :key="index"
          >
            <detail-render :list-item="item" :list="detail.values" />
          </el-form-item>
        </template>
        <component
          v-else
          :is="detailName"
          :detail="detail"
          :row="row"
          @onFileViewerItem="setFileViewerIndex"
          @getDetail="getDetail"
        ></component>
      </el-form>
    </div>
    <!-- 非其他页面打开 && 有审核场景 && 不是审核记录 -->
    <div
      class="task-detail-actions"
      v-if="
        !isOpenedByOther &&
          isPassShow &&
          auditRecordState == -1 &&
          detail.projectType !== 21
      "
    >
      <!-- 详情只可以操作，待审核(审核中) -->
      <!-- auditRecordState === -1表示任务记录打开，其他值为审核记录打开(已去掉审核记录操作) -->
      <!-- 协定服务-活动类型，判断与OSS不一样 -->
      <el-button
        :disabled="
          isUnqualified ||
            actionsDisabled ||
            detail.auditOssStatus != 1 ||
            detail.isOnOff == 2
        "
        size="medium"
        type="primary"
        @click="pass"
      >
        通过
      </el-button>
      <el-button
        :disabled="
          isUnqualified || actionsDisabled || detail.auditOssStatus != 1
        "
        size="medium"
        @click="noPass"
      >
        不通过
      </el-button>
    </div>
    <fileViewer
      v-if="!isFullScreen"
      ref="fileViewer"
      :initialIndex="fileViewerIndex"
      :fileList="fileViewerList"
    />
  </el-drawer>
</template>
<script>
import request from '@/tools/request';
import { mapActions } from 'vuex';
import fileViewer from '@R/components/file-viewer.vue';
import myIframe from '@R/components/iframe.vue';
import setFileViewerList, {
  getFileType
} from '@R/services/set-file-viewer-list';
import createExtend from '@C/createExtend';
import newRepeatPickure from './new-repeat-pickure-table.vue';
import { Task } from '../../api';

const detailComponents = {};
const files = require.context('@R/components/task-details', true, /\.vue$/);
files.keys().forEach(fileName => {
  const curFile = files(fileName).default;
  const curFileName = curFile.name;
  if (curFileName && curFileName.includes('detail')) {
    detailComponents[curFile.name] = curFile;
  }
});
const createDom = (r, ctx, name, values) => {
  if (values) {
    const fileType = getFileType(values);
    if (name || ['file', 'zip'].includes(fileType)) {
      return r('div', {}, [
        r(
          'el-tooltip',
          {
            props: {
              effect: 'dark',
              content: name || values,
              placement: 'left'
            }
          },
          [
            r(
              'div',
              {
                attrs: {
                  style: 'display: flex; align-items: center;width: 10vw;'
                }
              },
              [
                r(
                  'span',
                  {
                    attrs: {
                      class: 'pointer ellipsis',
                      style: 'color: #1296db;display: inline-block;'
                    },
                    on: {
                      click: function() {
                        if (['zip', 'file'].includes(fileType)) {
                          this.$previewFile(values);
                        } else {
                          ctx.parent.setFileViewerIndex(values);
                        }
                      }
                    }
                  },
                  name || '查看文件'
                ),
                ctx.parent.projectType !== 18 &&
                  r('img', {
                    attrs: {
                      src: require('@R/imgs/download.png'),
                      class: 'pointer',
                      style: 'width:15px;height:15px;'
                    },
                    on: {
                      click() {
                        ctx.parent.$downloadFile(values, true);
                      }
                    }
                  })
              ]
            )
          ]
        )
      ]);
    } else if (fileType === 'image') {
      return r('img', {
        attrs: {
          src: values,
          class: 'pointer',
          style: 'width: 88px;margin-right: 10px'
        },
        on: {
          click: function() {
            ctx.parent.setFileViewerIndex(values);
          }
        }
      });
    } else {
      return r('span', values ? values : '-');
    }
  } else {
    return r('span', '-');
  }
};

export default {
  name: 'task-detail',
  props: {
    index: {
      // 点击了表格第几项
      type: Number,
      default: 0
    },
    row: {
      type: Object,
      default: () => ({})
    },
    detailOptions: {
      type: Object,
      default: () => ({})
    },
    detailUrl: {
      type: String
    },
    // 2只展示不通过，3只展示通过，1都展示，0都不展示, -1默认（用去区分判断,使用其他字段判断操作disabled。只有在审核记录中使用了这个prop，并且审核记录中不需要通过其他字段判断disabled）
    auditRecordState: {
      type: Number,
      default: -1
    },
    // true其他页面打开，不展示操作。task-detail组件由于extends没有inject，再次以prop传入
    isOpenedByOther: {
      type: Boolean,
      default: false
    },
    // 审核记录中控制disabled，0-不可操作
    whetherThisRecordCanBeManipulated: {
      type: Number,
      default: 1
    }
  },
  provide() {
    return {
      row: this.row
    };
  },
  components: {
    ...detailComponents,
    fileViewer,
    detailRender: {
      functional: true,
      render(r, ctx) {
        const { listItem } = ctx.props;
        //typeValues 1 字符串 2 数字  3 List<String > 4 List[Object]
        const { typeValues, values } = listItem;
        // 字符串
        if (typeValues === 1 || typeValues === 2) {
          return createDom(r, ctx, '', values);
        }
        if (typeValues === 3) {
          const arr = values && values.length ? values : ['-'];
          return arr.map(i => {
            return createDom(r, ctx, '', i);
          });
        }
        // 优先处理特殊清空
        // 传递信息
        if (listItem.numberVisitTransmitMessages) {
          return values.map(i => {
            return (
              <a
                style="color: blue;width:100%"
                onClick={ctx.parent.showInformationRecord.bind(this, i)}
              >
                {'• ' + i.informationName}
              </a>
            );
          });
        }
        if (typeValues === 4) {
          return values.map(i => {
            return createDom(r, ctx, i.name, i.url);
          });
        }
      }
    }
  },
  data() {
    return {
      form: {},
      detail: {},
      values: [],
      fileViewerList: [],
      fileViewerIndex: `0_${Date.now()}`,
      nextTaskId: '', // 审核操作在外部处理，需要传给外部
      isPicRepeat: false, // true有重复图片
      isFullScreen: false
    };
  },
  computed: {
    // ...mapState('dataAnalysis/task', ['tableData']),
    // 操作 禁用
    isPassShow() {
      //数字专区，任务记录-查看详情页面不需要有审核按钮
      return this.$store.state.dataAnalysis.projectDetail.projectType !== 6;
    },
    projectType() {
      return this.$store.state.dataAnalysis.projectDetail.projectType;
    },
    actionsDisabled() {
      return +this.detail['isOnOff'] === 0; // 0不可操作 1可操作 2审核通过不可操作，不通过可操作
    },
    isUnqualified() {
      return this.row.dataState == 0 && this.row.superviseStatus == 3; // 数据检测不合格，系统拦截
    },
    // 特殊处理详情组件名
    detailName() {
      if ([21].includes(this.detail.projectType)) {
        return 'detail-21';
      }
      // 可配置、问卷用一个
      if ([5, 7, 20].includes(this.detail.projectType)) {
        return 'detail-20';
      }
      return `detail-${this.detail.projectType}`;
    }
  },
  methods: {
    showRepeat() {
      createExtend(newRepeatPickure, {
        projectId: this.detail.projectId,
        taskId: this.detail.taskId,
        isOpenedByOther: this.isOpenedByOther
      });
    },
    /**
     * @description: 设置预览下标
     * @param {string} url 当前点击url
     * @return {void} 直接修改了fileViewerIndex
     */
    setFileViewerIndex(url) {
      const index = this.fileViewerList.findIndex(item => item.url === url);
      if (~index) {
        this.fileViewerIndex = `${index}_${Date.now()}`;
      }
    },
    //引小程序页面
    showInformationRecord(item) {
      const src = `${this.$Config.webViewUrl}/html/index.html#/visit?id=${item.numberVisitId}&platform=oss`;
      this.$xrkDialog({
        title: '',
        width: '400px',
        showConfirm: false,
        cancelText: '确认',
        cancelType: 'primary',
        $slots: {
          default: this.$createElement(myIframe, {
            props: { src }
          })
        }
      });
    },
    async pass() {
      this.$emit('pass', 2, this.nextTaskId);
    },
    async noPass() {
      this.$emit('pass', 3, this.nextTaskId);
    },
    ...mapActions('dataAnalysis/task', ['audit']),
    handleClose() {
      this.$emit('close');
    },
    async getDetail(nextTaskId) {
      this.nextTaskId = nextTaskId;
      const taskId = nextTaskId || this.row.taskId || this.row.id; // 审核列表中使用id，优先使用传入的下一条数据id
      const {
        projectId = this.$route.query.projectId,
        type = 1,
        dataState = 0
      } = this.row;
      // 重复图片查询
      Task.findSimiForList({
        ids: taskId,
        projectId
      }).then(({ pdata }) => {
        this.isPicRepeat = !!Object.keys(pdata).length;
      });
      const res = await request.post(this.detailUrl, {
        projectId,
        taskId,
        type,
        dataState,
        ...this.detailOptions
      });
      let {
        data: { data: detail }
      } = res;
      this.detail = {
        ...detail,
        projectId,
        taskId
      };
      // 初始化预览数组
      this.fileViewerList = setFileViewerList(this.detail.values);
    },
    // 为了让file-viewer获取焦点，而可以使用内部键盘事件
    fileViewerFocus() {
      this.$nextTick(() => {
        this.$refs['fileViewer'].$refs['el-image-viewer__wrapper'].focus();
      });
    }
  },
  watch: {
    nextTaskId() {
      this.fileViewerIndex = `${0}_${Date.now()}`;
    }
  },
  created() {
    this.isFullScreen =
      this.$store.state.dataAnalysis.projectDetail.projectType == 6;
    this.getDetail();
  }
};
</script>

<style scoped lang="scss">
$action-bar-height: 80px;

.rectitle {
  height: 50px;
  margin: 0 20px;
  background-color: rgba(247, 217, 217, 1);
  border-radius: 10px;
  margin-bottom: 15px;
  &-text {
    line-height: 50px;
  }
}
>>> .el-form {
  padding: 10px 16px;
}
.task-detail {
  &-container {
    height: calc(100vh - 78px);
    position: relative;
    overflow-y: scroll;
    padding: 0 5px $action-bar-height;
    >>> .el-form-item__content {
      display: flex;
      flex-wrap: wrap;
    }
    >>> .el-form-item__label {
      width: 140px;
      font-size: 15px;
      font-weight: bold;
    }
  }

  &-actions {
    height: $action-bar-height;
    background: #fff;
    border-top: 1px solid #c1c1c1;
    width: 100%;
    position: absolute;
    bottom: 0;
    padding: 10px 50px;
  }
}
::v-deep .el-image-viewer__wrapper {
  width: 70% !important;
}
</style>
